<template>
  <app-page wide :title="title">
    <v-layout>
      <v-flex xs12>
        <contract-list
          :key="query.status"
          :filters="query"
          :headers="headers"
          @selected="onItemSelected"
          @beforeRequest="onBeforeRequest"
        ></contract-list>
      </v-flex>
    </v-layout>

    <v-btn
      v-if="!isCompanyAgent"
      fab
      dark
      color="pink"
      top
      right
      absolute
      style="top: 32px; right: -80px;"
      to="/contract"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </app-page>
</template>

<script>
import ContractList, { defaultHeaders } from './ContractList';
import { contractStatusLabel, ContractStatusEnum } from '../../constants';
import { mapGetters } from 'vuex';

export default {
  components: { ContractList },

  data() {
    return {
      query: {},
      headers: [
        {
          text: '@insurancesList/contactPersonPersonalNumberColumnHeader',
          align: 'left',
          sortable: true,
          value: 'contactPerson.ssn',
        },
        {
          text: '@insurancesList/contactPersonNameColumnHeader',
          sortable: true,
          value: 'contactPerson.fullName',
        },
        ...defaultHeaders,
      ],
    };
  },

  computed: {
    translatedHeaders() {
      return Array.isArray(this.headers)
        ? this.headers.map((h) => ({
            ...h,
            text: this.$t(h.text),
          }))
        : [];
    },
    title() {
      const val = ContractStatusEnum[this.query.status];
      const name = contractStatusLabel[val]
        ? this.$t(contractStatusLabel[val])
        : this.$t('@insurancesList/allInsurancesGroupName');

      return this.$t('@insurancesList/title', { insurancesGroupName: name });
    },

    ...mapGetters(['isCompanyAgent']),
  },

  methods: {
    onItemSelected(contract) {
      this.$router.push(`/contract/${contract.internalId}`);
    },

    onBeforeRequest(nextQuery) {
      // eslint-disable-next-line no-unused-vars
      const { status, ...rest } = nextQuery;

      // Update current route according to underlying data request
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...rest },
      });
    },

    setQueryFromRoute(route) {
      this.query = {
        ...this.query,
        ...route.query,
        status: route.params.status,
      };
    },
  },

  mounted() {
    this.setQueryFromRoute(this.$router.currentRoute);
  },

  beforeRouteUpdate(to, from, next) {
    this.setQueryFromRoute(to);
    next();
  },
};
</script>
